import React from "react";
import AOS from 'aos';
import "aos/dist/aos.css";
import { animateScroll as scroll } from 'react-scroll';

// import img
import Image from '../assets/img/44.png';


const scrollToBottom = () => {
  scroll.scrollToBottom();
};

const About = () => {
    AOS.init();
  return (
    <section className='section bg-quadrary1' id='about'>
      <div className='container mx-auto'>
        <div className='flex flex-col xl:flex-row gap-24' >
          <img
            className='object-cover h-full w-[466px] md:mx-auto lg:mx-0 rounded-2xl' data-aos='fade-left'
            src={Image}
            alt=''
          />
          <div className='flex flex-col items-center text-center lg:items-start lg:text-left' data-aos='fade-right'>
            <div className='flex flex-col font-tertiary'>
              <h2 className='text-3xl lg:text-4xl font-medium lg:font-extrabold mb-3 before:content-about relative before:absolute before:opacity-40 before:-top-[2rem] before:hidden before:lg:block'>
                SadiQ HabiL
              </h2>
              <p className='mb-4 text-accent text-2md lg:text-3md'>
              Software developer | Full-stack JavaScript | Node/React developer | Web developer
              </p>
              <hr className='mb-8 opacity-5' />
              <p className='mb-8 text-5md lg:text-3md'>
                📫 As someone who is always passionate for learning more about tech and life. I love to develop web scripts static websites and ever since been a self taught software developer also unstopped learner. I have evolved into a Full-stack Web Developer career path, and loves working with cutting edge tools and technologies. <br />
                <br />
                Programmer specialized in web development using multiple tools, frameworks and libraries both in frontend and backend. I pay a lot of attention to detail to generate best products.
              </p>
            </div>
            <button
            onClick={() => scrollToBottom()}
            className='btn btn-md rounded-md text-black bg-accent hover:bg-secondary-hover transition-all' data-aos='zoom-in'>

                <span>Contact me</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
